import React, { useState } from 'react'
import Layout from '../Layout'
import { Box, Button, Container, Grid, IconButton, TextField, Typography, makeStyles } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import { Add, Remove } from '@material-ui/icons';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import CustomBreadcrumbs from '../Breadcrumb';

const useStyles = makeStyles((theme) => ({
    quantityBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid #ccc',
        borderRadius: '8px',
        padding: theme.spacing(1),
    },
    iconButton: {
        backgroundColor: '#f0f0f0', // Background color for the icons
        '&:hover': {
            backgroundColor: '#e0e0e0',
        },
    },
    quantity: {
        backgroundColor: '#ffffff', // Background color for the quantity
        padding: theme.spacing(0, 2),
        borderRadius: '4px',
        margin: '0 10px',
    },
}));


const SpareList = () => {
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Breakdown Management', href: '/breakdown-management' },
        { label: 'Current Breakdowns', href: '/breakdown-management/current-breakdowns' },
    ];
    const classes = useStyles();
    const [checkpoints, setCheckpoints] = useState([{ type: '', name: '', value: '' }]);
    const [quantity, setQuantity] = useState(0);

    const handleIncrease = () => {
        setQuantity(quantity + 1);
    };

    const handleDecrease = () => {
        if (quantity > 0) {
            setQuantity(quantity - 1);
        }
    };
    const addRow = () => {
        setCheckpoints([...checkpoints, { type: '', name: '', value: '' }]);
    };

    const handleChange = (index, field, value) => {
        const updatedCheckpoints = checkpoints.map((checkpoint, i) => (
            i === index ? { ...checkpoint, [field]: value } : checkpoint
        ));
        setCheckpoints(updatedCheckpoints);
    };

    const handleDelete = (index) => {
        setCheckpoints(checkpoints.filter((_, i) => i !== index));
    };
    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Spares List
                    </Typography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Spare List" />
                </Box>
                <Box mb={2}>
                    <div className="checkpoint-box">
                        <Grid container spacing={3}>
                            <Grid item>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                    onClick={addRow}>
                                    Add Row
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} alignItems='center'>
                            <Grid item xs={5}>
                                <h4>Spare</h4>
                            </Grid>
                            <Grid item xs={2}>
                                <h4>Stock</h4>
                            </Grid>
                            <Grid item xs={3}>
                                <h4>Quantity</h4>
                            </Grid>
                            <Grid item xs={2}>
                                <h4>Action</h4>
                            </Grid>
                        </Grid>
                        <hr />
                        {checkpoints.map((checkpoint, index) => (
                            <Grid container spacing={3} alignItems='center' key={index}>
                                <Grid item xs={5}>
                                    <TextField
                                        label="Spare"
                                        name="name"
                                        type="text"
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={checkpoint.name}
                                        onChange={(e) => handleChange(index, 'name', e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <p>N/A</p>
                                </Grid>
                                <Grid item xs={3}>
                                    <Box className={classes.quantityBox}>
                                        <IconButton onClick={handleDecrease} size="small" className={classes.iconButton}>
                                            <Remove />
                                        </IconButton>
                                        <Typography variant="body1" className={classes.quantity}>
                                            {quantity}
                                        </Typography>
                                        <IconButton onClick={handleIncrease} size="small" className={classes.iconButton}>
                                            <Add />
                                        </IconButton>
                                    </Box>
                                </Grid>
                                <Grid item xs={2} >
                                    <DeleteIcon onClick={() => handleDelete(index)} />
                                </Grid>
                            </Grid>
                        ))}
                        <hr />

                    </div>
                </Box>
                <Box>
                    <Grid container justifyContent="center" alignItems="center">
                        <Grid item xs={8}>
                            <Button
                                className={classes.button}
                                variant="contained"
                                color="primary"
                                fullWidth
                                startIcon={<AddCircleOutlineIcon />}
                            >
                                Save Spares
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Layout>
    )
}

export default SpareList